import React from "react";

import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { green, red, lightBlue, yellow } from "@mui/material/colors";

type IconSize = "small" | "inherit" | "medium" | "large";
type ButtonType = "success" | "danger" | "warning" | "info" | "generic";

interface IconBtnTemplateProps {
  action: (event?: React.MouseEvent<HTMLButtonElement>) => void;
  type?: ButtonType;
  size?: IconSize;
  icon: React.ReactElement;
  tip?: string;
  children?: React.ReactNode;
  className?: string;
}

const getButtonStyles = (type: ButtonType) => {
  const baseStyles = {
    "&:focus": {
      outline: "0",
    },
  };

  switch (type) {
    case "success":
      return {
        ...baseStyles,
        color: green[700],
        "&:hover": {
          color: green[500],
        },
      };
    case "danger":
      return {
        ...baseStyles,
        color: red[700],
        "&:hover": {
          color: red[500],
        },
      };
    case "warning":
      return {
        ...baseStyles,
        color: yellow[700],
        "&:hover": {
          color: yellow[500],
        },
      };
    case "info":
      return {
        ...baseStyles,
        color: lightBlue[700],
        "&:hover": {
          color: lightBlue[500],
        },
      };
    default:
      return baseStyles;
  }
};

export default function IconBtnTemplate(props: IconBtnTemplateProps) {
  const {
    action,
    type = "generic",
    size,
    icon,
    tip,
    children,
    className,
  } = props;
  const Icon = icon;

  return (
    <Tooltip title={tip || ""} placement="top">
      <IconButton
        sx={getButtonStyles(type)}
        className={className}
        onClick={(event) => {
          action(event);
        }}
      >
        {React.cloneElement(Icon, {
          fontSize: size,
        })}
        {children}
      </IconButton>
    </Tooltip>
  );
}
